module.exports = __webpack_public_path__ + "static/media/helmet.dc81c0a6.svg";